<template>
  <ClientModal class="new-password-modal" width="685px" @close="close">
    <h1 class="modal-header">Reset Client’s Password</h1>
    <p class="modal-description small-margin">
      Your client's Password has been reset. Please take a moment to copy the password to a safe location. The password
      will be encrypted once the client profile is registered. For security purpose, our system will not be able to
      decrypt the password for you.
    </p>

    <button type="button" v-if="showCSVDownload" class="confirm-button icon-btn" @click="downloadCSV">
      <inline-svg :src="$assets.svg['download_icon']" height="100%" />
      <span>Download CSV</span>
    </button>

    <ul class="client-password-list">
      <li class="client-info header">
        <p class="client-id">Client ID</p>
        <p class="client-password">Password</p>
        <p class="copy-btn"></p>
      </li>

      <li v-for="client in passwordClientList" :key="client.code" class="client-info">
        <p class="client-id">{{ client.code }}</p>
        <p class="client-password">{{ client.password }}</p>
        <button type="button" class="copy-btn confirm-button" @click="copyPassword(client.password)">
          Copy Password
        </button>
      </li>
    </ul>

    <GlobalLoading v-if="isLoading" />
  </ClientModal>
</template>

<script setup>
import { ref } from 'vue';

import $assets from '@/assets';
import ClientModal from '@/components/client/ClientModal.vue';
import GlobalLoading from '@/components/common/GlobalLoading.vue';

const emit = defineEmits(['close']);
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  showCSVDownload: {
    type: Boolean,
    default: false,
  },
  passwordClientList: {
    type: Array,
    default: () => [],
  },
});

const isLoading = ref(false);

function downloadCSV() {
  isLoading.value = true;

  const csv = props.passwordClientList.reduce((accum, client) => {
    const newline = `\n${client.code},${client.password}`;
    return accum.concat(newline);
  }, 'Code,Password');

  const blob = new Blob([csv], { type: 'text/csv' });
  const a = document.createElement('a');
  a.href = window.URL.createObjectURL(blob);
  a.download = 'Client Passwords.csv';
  a.click();

  isLoading.value = false;
}

function copyPassword(password) {
  navigator.clipboard.writeText(password);
}
function close() {
  emit('close');
}
</script>

<style scoped>
.modal .modal-header {
  margin-top: 0;
}
.modal .modal-description {
  color: #1e1e1e;
  margin-bottom: 1.7em;
}
.modal .modal-description.small-margin {
  color: #1e1e1e;
  margin-bottom: 2em;
}
.modal .confirm-button {
  height: 42px;
  width: 210px;

  background: #62a517;
  border: none;
  border-radius: 9px;

  color: #ffffff;
  text-align: center;

  font-family: 'LatoRegular';
  font-weight: 700;
  font-size: 15px;

  cursor: pointer;
}
.modal .client-password-list {
  flex: 1;
  width: 100%;
  color: black;
}
.modal .client-password-list .client-info {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  padding: 0.6em 18px 1em 18px;

  border-bottom: 2px solid #eae6e6;
}
.modal .client-password-list .client-info:not(.header) {
  font-family: 'RobotoSlab';
  font-weight: 300;
}
.modal .client-password-list .client-info:first-of-type {
  padding-bottom: 0;
}
.client-password-list .client-info .client-id {
  width: 7em;
}
.client-password-list .client-info .copy-btn {
  width: 13.6em;
}

.icon-btn {
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon-btn svg {
  height: 27px;
  fill: #808285;
}
.icon-btn > span {
  white-space: nowrap;
  margin-left: 0.5em;
}
</style>
